module.exports = __webpack_public_path__ + "img/asmntdoneicon.0028bcbc.svg";